import { render, staticRenderFns } from "./StudentInformation.vue?vue&type=template&id=ebead038&scoped=true"
import script from "./StudentInformation.vue?vue&type=script&lang=js"
export * from "./StudentInformation.vue?vue&type=script&lang=js"
import style0 from "./StudentInformation.vue?vue&type=style&index=0&id=ebead038&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebead038",
  null
  
)

export default component.exports